import { cn } from '@/lib/utils';
import { TrendingUp, TrendingDown } from 'lucide-react';

export interface StatCardProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error';
  trend?: number;
  className?: string;
}

export function StatCard({
  label,
  value,
  icon,
  variant = 'default',
  trend,
  className,
}: StatCardProps) {
  const variants = {
    default: 'bg-white',
    success: 'bg-success/5 border-success/20',
    warning: 'bg-warning/5 border-warning/20',
    error: 'bg-error/5 border-error/20',
  };

  return (
    <div
      className={cn(
        'rounded-xl border border-neutral-light p-4',
        variants[variant],
        className
      )}
    >
      <div className="flex items-start justify-between mb-2">
        {icon && (
          <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary">
            {icon}
          </div>
        )}
        {trend !== undefined && (
          <div
            className={cn(
              'flex items-center gap-1 text-xs font-medium',
              trend >= 0 ? 'text-success' : 'text-error'
            )}
          >
            {trend >= 0 ? (
              <TrendingUp className="w-3 h-3" />
            ) : (
              <TrendingDown className="w-3 h-3" />
            )}
            {Math.abs(trend)}%
          </div>
        )}
      </div>
      <p className="text-2xl font-bold text-neutral-dark mb-1">{value}</p>
      <p className="text-xs text-neutral-medium">{label}</p>
    </div>
  );
}
